export default class scrollCheckSp {
  isScrollDown() {
    let lastY = $(window).scrollTop();
    let _this = this;
    if (lastY >= 0) {
      let position;

      function getPosition(event) {
        return event.originalEvent.touches[0].screenY;
      }

      $(document).on('touchstart', function (e) {
        position = getPosition(e);
      });

      $(document).on('touchmove', function (e) {
        const currentY = getPosition(e);
        if (currentY < position - 10) {
          // callback(true);
          _this.doti(true);
        } else if (currentY > position + 10) {
          // callback(false);
          _this.doti(false);
        }
      });

      $(window).on('scroll', function (e) {
        const currentY = $(this).scrollTop();
        if (currentY < lastY - 10) {
          // callback(false);
          _this.doti(false);
        } else if (currentY > lastY + 10) {
          // callback(true);
          _this.doti(true);
        }
        lastY = currentY;
      });

      $(window).on('resize', function (e) {
        const outerHeight = $(window).outerHeight();
        const innerHeight = $(window).innerHeight();
        if (outerHeight !== innerHeight) {
          // callback(true);
          _this.doti(true);
        } else {
          // callback(false);
          _this.doti(false);
        }
      });
    }
  }

  doti(e) {
    if (e) {
      if (!$("body").hasClass("is-open")) {
        $(".l-header").removeClass("is-scroll-up");
        $("#content").removeClass("is-scroll-up");
      }
      if ($(".l-header .header-button").hasClass("is-open")) {
        // $(".l-header .header-button").toggleClass("is-open");
        // $(".l-header .header-button").slideUp(300);
      }


      // 一時的（SPメニューが変更されるまで）
      // $(".l-header").removeClass("is-scroll-up");
      // $("#content").removeClass("is-scroll-up");
      // if ($(".l-header .header-button").hasClass("is-open")) {
      //   $(".l-header .header-button").toggleClass("is-open");
      //   $(".l-header .header-button").slideUp(300);
      // }

      $(".section-table").removeClass("is-scroll-up");
    } else {
      $(".l-header").addClass("is-scroll-up");
      $("#content").addClass("is-scroll-up");

      $(".section-table").addClass("is-scroll-up");
    }
  }
}
